module.exports = __webpack_public_path__ + "static/media/basic_user_two.c0fba258.png";